var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SummaryContainer',{attrs:{"project":_vm.selectedProject,"month":_vm.selectedMonth},on:{"change-month":_vm.handleSelectMonth}})}
var staticRenderFns = []

export { render, staticRenderFns }